import { Component, OnInit, Input } from '@angular/core';
import { Category } from "../../../app.models";


// ******************************************* APP MENU COMPONENT CLASS *********************************************
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  @Input('categories') categories: Array<Category> = [];


  // -- FUNC Constructor
  constructor() { }


  // -- FUNC Ng On Init
  ngOnInit() { }


  // -- FUNC Open Mega Menu
  openMegaMenu(){
    let pane = document.getElementsByClassName('cdk-overlay-pane');
    [].forEach.call(pane, function (el) {
        if(el.children.length > 0){
          if(el.children[0].classList.contains('mega-menu')){
            el.classList.add('mega-menu-pane');
          }
        }        
    });
  }

}
